import type { ComponentProps, ReactNode } from 'react'
import { cn } from '../lib/cn'
import { Card, CardBody, CardHeader } from './card'
import { FileInput } from './file-input'

export function MaterialsPanel({
  header,
  headerAppearance = 'plain',
  files,
  notes,
  className,
  ...props
}: Omit<ComponentProps<typeof Card>, 'children' | 'padding'> & {
  header: ReactNode
  headerAppearance?: 'plain' | 'accent'
  files: ReactNode
  notes: ReactNode
}) {
  return (
    <Card {...props} padding="none" className={cn('overflow-hidden', className)}>
      <CardHeader
        className={cn(
          'mb-0 flex-nowrap items-center px-5 py-4 sm:px-6',
          headerAppearance === 'accent' ? 'bg-accent/35' : 'border-b border-border',
        )}
      >
        {header}
      </CardHeader>
      <CardBody className="grid lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
        <div className="min-w-0 space-y-4 p-5 sm:p-6">{files}</div>
        <div className="min-w-0 space-y-4 border-t border-border bg-accent/25 p-5 sm:p-6 lg:border-t-0 lg:border-l">
          {notes}
        </div>
      </CardBody>
    </Card>
  )
}

export function MaterialsUpload({ className, ...props }: ComponentProps<typeof FileInput>) {
  return (
    <FileInput
      {...props}
      className={cn(
        'flex h-auto w-full flex-col gap-2 rounded-panel border-dashed bg-muted/25 px-5 py-6 text-center whitespace-normal hover:border-action/50 hover:bg-accent/30',
        className,
      )}
    />
  )
}
